<template>
  <v-container>
    <template>
      <CRUDCriteria :showReset="false" :showSearch="false">
        <template v-slot:criteriaRows>
            <v-row class="pa-0">
                <v-col cols="3" class="pa-0 ma-0 ml-2">
                  <v-text-field class="input-text-size" label="Locate Street"
                   v-model="criteriaState.streetName" @input="searchByTimeOut" />
                </v-col>
                <v-col cols="3">
                  <v-btn class="input-text-size" text color="primary"
                   @click="reUpdateTheCollection">Update Streets List</v-btn>
                </v-col>
            </v-row>
        </template>
      </CRUDCriteria>
    <CRUDList
      ref="crudList"
      :canAdd="false"
      :canEdit="true"
      :canSave="false"
      :showSelect="false"
      :enableFixedHeaders="true"
      :displayTopPagination="false"
      :headers="headers"
      :selectedItems="selectedItems"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      dialogDynamicWidth="30vw"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='350'
      @emitSelectedItem="emitSelectedItem"
      :canDeleteInDialog="false"
      @loadCRUDList = "handleLoadTaxStreetList"
     :loadingData="gridLoading.flag"
     :loadingText="gridLoading.text"
   >
   <template v-slot:[`editedItem`]="{ }">
      <taxstreetsDialog />
    </template>
   </CRUDList>
  </template>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import { TaxStreetsHeaders } from '../Utils/taxHeaders.utils';
import taxstreetsDialog from './taxStreetsDialog.vue';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import '../../../assets/style.css';
import { SEARCH_DEBOUNCE_TIMER } from '../../tax/common-utils/constants';

export default {
  name: 'taxStreetList',
  components: {
    CRUDList,
    CRUDCriteria,
    taxstreetsDialog,
  },
  data() {
    return {
      baseCrudKey: 'taxStreetsTable',
      headers: TaxStreetsHeaders,
      gridLoading: defaultGridLoading(),
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
    ]),
    ...mapState({
      StoreSelItems: (state) => state.shared.TaxStreets.selectedItems,
    }),

    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'streetName',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('shared/TaxStreets', [
      'setSelectedItems',
    ]),
    ...mapActions('shared/TaxStreets', [
      'loadTaxStreetsRecords',
      'upsertTaxStreets',
      'deleteTaxStreet',
      'taxStreetReUpdateTheCollection',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions(['reAuth', 'flashSuccess', 'flashError']),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    searchByTimeOut() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(() => {
        this.handleLoadTaxStreetList();
      }, SEARCH_DEBOUNCE_TIMER);
    },
    handleLoadTaxStreetList() {
      const { baseCrudKey } = this;
      const criteriaList = {
        ...this.criteriaState,
      };
      manageGridLoading(this, true, 'Searching...');
      this.loadTaxStreetsRecords({ baseCrudKey, criteria: criteriaList }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    async reUpdateTheCollection() {
      const taxStreetReUpdateTheCollection = await this.taxStreetReUpdateTheCollection();
      if (taxStreetReUpdateTheCollection.statusCode === 200) {
        this.flashSuccess('Tax street collection updated successfully.');
        this.handleLoadTaxStreetList();
      } else {
        this.flashError('There was a problem updating the tax street collection.');
      }
    },
  },
};
</script>
